

// A RTCIceCandidate like object exposed for native WebRTC compatability
module.exports = function RTCIceCandidate(options) {
  this.sdpMid = options.sdpMid;
  this.sdpMLineIndex = parseInt(options.sdpMLineIndex, 10);
  this.candidate = options.candidate;
};



// WEBPACK FOOTER //
// ./src/js/otplugin/rtc/rtc_ice_candidate.js